import { gql } from 'apollo-angular';

import { PRODUCT_LINE_DIMENSIONS_FRAGMENT } from 'graphql/fragments/product-line-dimensions';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';

export const PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT = gql`
  fragment ProductLineWithoutPricingFragment on ProductLine {
    id
    number
    description
    quantity {
      unit
      value
    }
    parentLine {
      id
    }
    isSubLine
    product {
      name
      description
      isConfigurable
      properties {
        name,
        value
      }
    }
    customProperties {
      stringValue
      key
    }
    ...ProductLineDimensionsFragment
  }
  ${PRODUCT_LINE_DIMENSIONS_FRAGMENT}
`;

export const PRODUCT_LINE_FRAGMENT = gql`
  fragment ProductLineFragment on ProductLine {
    ...ProductLineWithoutPricingFragment
    ...ProductLinePricingFragment
  }
  ${PRODUCT_LINE_WITHOUT_PRICING_FRAGMENT}
  ${PRODUCT_LINE_PRICING_FRAGMENT}
`;
